import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
    useTheme,
} from '@material-ui/core'
import { useStyles } from './forgottenPasswordDialog.css'
import CloseButton from 'components/dialogs/closeButton'
import { Trans } from 'react-i18next'
import ForgottenPasswordCodeForm, {
    ForgottenPasswordCodeFormState,
} from 'components/forms/auth/forgottenPasswordCodeForm'
import SubmitButton from '../../../common/submitButton'
import clsx from 'clsx'

interface Props {
    open: boolean
    onClose: () => void
    email: string
    onSubmit: (values: ForgottenPasswordCodeFormState) => void
    inProgress: boolean
    initialValues: ForgottenPasswordCodeFormState
}

const ForgottenPasswordDialog: React.FC<Props> = ({ open, onClose, email, ...formData }) => {
    const classes = useStyles()
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'))

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
        >
            <ForgottenPasswordCodeForm formClassName={classes.form} {...formData}>
                {(content, actions) => (
                    <>
                        <DialogTitle>
                            <Trans i18nKey="views.forgottenPasswordCode.title" />
                        </DialogTitle>
                        <DialogContent dividers>
                            <CloseButton onClose={onClose} />
                            <DialogContentText>
                                <Trans i18nKey="views.forgottenPasswordCode.code" values={{ email }} />
                            </DialogContentText>
                            {content}
                        </DialogContent>
                        <DialogActions className={classes.actions}>
                            <Button variant="contained" onClick={onClose}>
                                <Trans i18nKey="actions.cancel" />
                            </Button>
                            {actions.map((action, index) => (
                                <SubmitButton
                                    key={index}
                                    variant="contained"
                                    color="primary"
                                    {...action}
                                    className={clsx(action.className)}
                                />
                            ))}
                        </DialogActions>
                    </>
                )}
            </ForgottenPasswordCodeForm>
        </Dialog>
    )
}

export default ForgottenPasswordDialog
